import { Router } from '@angular/router';
import { Component, OnInit, HostListener, ViewChild, ElementRef, OnDestroy } from '@angular/core';

import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { CustomService } from '../../services/custom.service';
import { AppManagementService } from '../../services/app-management.service';
import { AppTexts, ScreenNames } from '../../objects/app-static-texts';

@Component({
  selector: 'app-camera',
  templateUrl: './camera.component.html',
  styleUrls: ['./camera.component.scss']
})
export class CameraComponent implements OnInit, OnDestroy {
  // FLAG FOR VIEW SWITCH BETWEEN CUSTOM AND TEMPLATE DESIGN
  customDesign:boolean = false;
  constraints = { audio: false, video: { width: 1280, height: 720 } }; 

  // CAMERA OVERLAY OBJECT
  camera_overlay:any;
  overlayStyle: any;


  // CAMERA DIMENSION
  camera_dim:any;

  //STYLE FOR BUTTON CONTAINER
  camera_button_container_style:any;

  isMobile: boolean = false;

  // VARIABLE FOR STORING CUSTOM CODE STRING
  htmlText: any;
  cameraSrc:any;
  @ViewChild('cameraContainer') cameraContainer: ElementRef;
  cameraAccessDenied: boolean = false;

  screen_width: number;
  pageDesignFlag: boolean =false;
  pageDesign: any;
  containerStyle:any;
  
  enableOverlay: boolean = false;
  cameraOverlayText: null;
  cameraOverlayImage: null;

  screen_height: number;
  mirrorImageStatus: string;

  // toggle webcam on/off
  public showWebcam = true;
  public allowCameraSwitch = false;
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  public videoOptions: MediaTrackConstraints = {
  };
  public errors: WebcamInitError[] = [];

  public webcamImage: WebcamImage = null;

  private trigger: Subject<void> = new Subject<void>();
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();

  // public video =null;
  public canvas =null;
  public photo =null;
  public output =null;
  public camera =null;
  public startbutton =null;
  public streaming = false;
  
  public width = 320;    
  public height = 0;     
  
  media_devices: any;

  public video =null;

  constructor(
    private router: Router,
    public customService: CustomService,
    public appDesignService: AppManagementService
    ) {
      
    this.getScreenSize(this);
   }

  ngOnInit() {
    this.isMobile =  this.appDesignService.isMobile;
    this.pageDesign = this.appDesignService.getPageDesign();

    if(this.pageDesign!=undefined){
      this.pageDesignFlag = true;

      this.pageDesign[AppTexts.style] = this.appDesignService.applyElementStyle(this.pageDesign);

      //IF PAGE DESIGN HAVE CUSTOM CODE
      if(this.pageDesign.custom_code !=undefined){
          
        //DECODE BASE64 CUSTOM CODE TO STRING
        this.htmlText = atob(this.pageDesign.custom_code);
        this.customDesign = true;
        var start=0;
        var end=0;
        
        for(let i = 0; i < this.htmlText.length; i++){
          if(this.htmlText[i]+""+this.htmlText[i+1] == "{{") { start = i+2 }
          if(this.htmlText[i]+""+this.htmlText[i+1] == "}}") { end = i; }
          if(start-end<0){
            var c = this.htmlText.substring(start,end);
            var value = '';  
            for(var e=0;e<this.pageDesign.element_flow.length;e++){
              if(this.pageDesign.element_flow[e].element_keyname == c){
                switch(this.pageDesign.element_flow[e].element_keyname) {
                  case 'screen_image_1':
                    value = this.pageDesign.element_flow[e].src;
                    break;
                  default:
                    value = this.pageDesign.element_flow[e].text;
                }
              }
            }
            this.htmlText = this.htmlText.replace("{{"+c+"}}",value);
            start = end = 0;
          }
        }
      }
      if(this.pageDesign.element_flow.length>0){
        var overlay_flg = true;
        var cam_dimension_flg = true;
        for(var e=0;e<this.pageDesign.element_flow.length;e++){
          if(this.pageDesign.element_flow[e].type==ScreenNames.camera){
            if(this.pageDesign.element_flow[e].overlay!=undefined){
              overlay_flg = false;
              this.camera_overlay = this.pageDesign.element_flow[e].overlay;
            }
            if(this.pageDesign.element_flow[e].dimension!=undefined){
              cam_dimension_flg = false;
              this.camera_dim = this.pageDesign.element_flow[e].dimension;
            }
          }
          
          this.pageDesign.element_flow[e][AppTexts.style] = this.appDesignService.applyElementStyle(this.pageDesign.element_flow[e]);
          
          if(this.pageDesign.element_flow[e].type=='button_container'){
            this.camera_button_container_style = this.appDesignService.applyElementStyle(this.pageDesign.element_flow[e]);            
            for(var b=0;b<this.pageDesign.element_flow[e].buttons.length;b++){
              this.pageDesign.element_flow[e].buttons[b].style =  this.appDesignService.applyElementStyle(this.pageDesign.element_flow[e].buttons[b]);
            }
          }
        }

        if(overlay_flg) { this.camera_overlay = this.appDesignService.getCameraOverlayObject(); }
        if(cam_dimension_flg) { this.camera_dim =  this.appDesignService.getCameraDimension(); }
      }

      this.containerStyle = this.appDesignService.applyStyles(['camera_container']);
      if(this.camera_overlay!=undefined) { this.enableOverlay = this.camera_overlay.enabled; }
      
      if(this.enableOverlay) {
        this.cameraOverlayText = this.camera_overlay.text;
        var classList = this.camera_overlay.class.common;
        if(this.isMobile) { classList = classList.concat(this.camera_overlay.class.mobile); }
        this.overlayStyle = this.appDesignService.applyStyles(classList);
      }
      
      WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.media_devices = mediaDevices;
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
        this.appDesignService.sentPostMessageToParent("cameraContainer");
        if(document.getElementById('camera-buttons-container')!=null) { this.updateIframeHeight(); }
      });
      // this.appDesignService.scrollToTop();
      setTimeout(() => { this.updateIframeHeight(); }, 1000);
    }
    else{
      this.appDesignService.redirectAppToBase();
    }
  }

  public ngAfterViewInit() { this.toggleVideo(true); }

  public triggerSnapshot(): void { this.trigger.next(); }
  
  ngAfterViewChecked() { this.updateIframeHeight(); }
  
  public toggleWebcam(): void { this.showWebcam = !this.showWebcam; }
  
  public handleInitError(error: WebcamInitError): void {
    if(error.message == 'Permission denied'){
      this.cameraAccessDenied = true;
      this.cameraContainer.nativeElement.style.display = "none";
      console.log("permission denied");
      this.customService.openSnackBarMessage("Please allow camera access before proceeding",0,'bottom');
      this.loadSelfieScreen();
    }  
  }

  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    this.allowCameraSwitch = true;
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
    this.allowCameraSwitch = false;
  }

  public handleImage(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;
    this.customService.setImageUrl(webcamImage.imageAsDataUrl);
    this.customService.setClickedBtn(this.customService.getClickedBtn())
    this.customService.getImageDataApi();
  }

  public cameraWasSwitched(deviceId: string): void { this.deviceId = deviceId; }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?: this) {
    
    this.screen_height = window.innerHeight;    
    this.screen_width = window.innerWidth;

    if(this.camera_dim!=undefined){
      if(this.camera_dim.common!=undefined){ 
        if(this.camera_dim.common.custom){
          this.screen_height = this.camera_dim.common.height;
          this.screen_width = this.camera_dim.common.width;
        }
      }
      
      if(this.camera_dim.mobile!=undefined){      
        if(this.camera_dim.mobile.custom){
          this.screen_height = this.camera_dim.mobile.height;
          this.screen_width = this.camera_dim.mobile.width;
        }
        else{
          this.applyFullScreenCamera();
        }
      }
    }

    if(this.isMobile){
      this.screen_height = (75* this.screen_height)/100;
    }
    else{
      // 70% of original screen size for camera 
      this.screen_height = (65* this.screen_height)/100;
    }
    
  
  }

  getCameraViewPortStyle() { return this.appDesignService.applyStyles(['camera-view-container']); }

  loadSelfieScreen() { 
    this.appDesignService.setNextPageId(ScreenNames.selfie);
    this.router.navigate(["/"+ScreenNames.selfie], { queryParamsHandling: 'preserve' }); 
    this.appDesignService.scrollToTop()
  }
  
  @HostListener('click', ['$event'])
  onClick(event: any) {    

    if(event.target.name == 'back_button'){
      var video = document.querySelector('video');
      video.pause();
      video.srcObject = null;
      var constraints = { audio: false, video: false };
      if (navigator.mediaDevices.getUserMedia !== null) {
        navigator.mediaDevices.getUserMedia(constraints)
        .then(function(mediaStream) {
          mediaStream.getTracks()[0].stop();
        })
        .catch(function(err) { 
          console.log(err.name + ": " + err.message); 
        });

        setTimeout(() => {
          this.loadPrevious();
        }, 1000);
      }
    }

    if(event.target.name == 'retry_button') { this.toggleVideo(true); }

    if(event.target.name == 'selfie_button'){

      var canvas = document.createElement('canvas');
      var video = document.querySelector('video');
      canvas.width = video.offsetWidth;
      canvas.height = video.offsetHeight;
      
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
      
      video.pause();
      video.srcObject = null;
      var constraints = { audio: false, video: true };
      
      if (navigator.mediaDevices.getUserMedia !== null) {
        navigator.mediaDevices.getUserMedia(constraints)
        .then(function(mediaStream) {
          mediaStream.getTracks()[0].stop();
        })
        .catch(function(err) { 
          console.log(err.name + ": " + err.message); 
        });
      }

      document.getElementById('container').style.display = "none";
      var dataURL = canvas.toDataURL();
      var canvas_img = document.getElementById("canvas_img");
      canvas_img.setAttribute("src",dataURL);
      var clicked_canvas = document.getElementById("clicked_canvas");
      clicked_canvas.style.display = "flex";
      this.customService.setImageUrl(dataURL);
      var retry_button = document.getElementById("retry_button");
      retry_button.style.display = "flex";
      
      if(this.pageDesign.element_flow.length>0){
        for(var e = 0;e<this.pageDesign.element_flow.length;e++){
          if(this.pageDesign.element_flow[e].element_keyname == event.target.name){
            this.customService.setClickedBtn(this.pageDesign.element_flow[e]);
            this.customService.getImageDataApi();
          }
        }
      }
    }
    
    //ENABLE CLICK ON CAMERA SCREEN TO CLICK THE IMAGE
    if(this.isMobile){
      if(event.target.tagName.toLowerCase() === 'video'){
        if(this.camera_dim.mobile!=undefined){
          if(this.camera_dim.mobile.touchscreen!=undefined){
            if(this.camera_dim.mobile.touchscreen){
              this.triggerSnapshot();
            }
          }
        }
      }
    }
  }

  loadPrevious(){
    // CHECK IF SURVEY HAS ALREADY STARTED
    var flag= this.customService.isSurveyContinued();
    var selected_queries = this.customService.getSelectedQueries();
    if(selected_queries!=undefined){
      if(selected_queries.length<1) { flag = false; }
    } else {
      flag = false;
    }

    if(flag){
      var selectedOptions = this.customService.getSelectedQueries();
      var remOp = selectedOptions[selectedOptions.length-1];
      if(remOp.type == AppTexts.screen && remOp.screen_name == ScreenNames.selfie){
        selectedOptions.pop();
        this.customService.saveSelectedQueries(selectedOptions);
      }
      this.customService.setBackButtonClicked(true);
      this.customService.loadSurveyScreen();
    } else {
      this.appDesignService.loadPrevious();
    }
  }

  toggleVideo(enable: boolean){
    var constraints = {};
    if(enable){
      constraints = { audio: false, video: { width: 1280, height: 720 } }; 
    }
    else{
      constraints = { audio: false, video: true }; 
    }

    var clicked_canvas = document.getElementById("clicked_canvas");
    var video_container = document.getElementById('container');
    var retry_button = document.getElementById("retry_button");
    var video = document.querySelector('video');
    if(video!=null){
      video.classList.add('loading');
      navigator.mediaDevices.getUserMedia(constraints)
        .then(function(mediaStream) {
          if(enable){
            video.srcObject = mediaStream;
            if(clicked_canvas!=undefined){
              clicked_canvas.style.display = "none";
            }
            if(video_container!=undefined){
              video_container.style.display = "flex";
            }
            if(retry_button!=undefined){
              retry_button.style.display = "none";
            }
            video.onloadedmetadata = function(e) {
              video.classList.remove('loading');
              video.play();
            };
          }
          else{
            mediaStream.getVideoTracks()[0].stop();
            if(clicked_canvas!=undefined){
              clicked_canvas.style.display = "flex";
            }
            if(video_container!=undefined){
              video_container.style.display = "none";
            }
            if(retry_button!=undefined){
              retry_button.style.display = "flex";
            }

            const tracks = mediaStream.getTracks();
            tracks[0].stop();
            tracks.forEach(track => track.stop());
          }
        })
        .catch(function(err) {   
          console.log(err.name + ": " + err.message); 
        }
      );
    }
  }

  applyFullScreenCamera(){
    const width  = window.innerWidth || document.documentElement.clientWidth || 
    document.body.clientWidth;
    const height = window.innerHeight|| document.documentElement.clientHeight|| 
    document.body.clientHeight;
    this.screen_width = width;
    this.screen_height = height;
  }

  updateIframeHeight(){
    var ele = document.getElementById('cam-main-container');
    if(ele!=null && ele!=undefined){
      var offsetHeight = ele.offsetHeight;
      this.appDesignService.sentHeight(offsetHeight);
    }
  }

  ngOnDestroy(): void {
    var constraints = { audio: false, video: true }; 
    navigator.mediaDevices.getUserMedia(constraints)
      .then(function(mediaStream) {
          mediaStream.getVideoTracks()[0].stop();
          const tracks = mediaStream.getTracks();
          tracks[0].stop();
          tracks.forEach(track => track.stop());          
      })
      .catch(function(err) { 
        console.log(err.name + ": " + err.message); 
      }
    );
  }
}
